import { useState } from "react";
import { C } from "../lib/theme";
import { Icon } from "./Icon";

const MEN_SIZES = [
  { uk: "5", us: "6", eu: "38" },
  { uk: "6", us: "7", eu: "39" },
  { uk: "6.5", us: "7.5", eu: "40" },
  { uk: "7", us: "8", eu: "41" },
  { uk: "8", us: "9", eu: "42" },
  { uk: "9", us: "10", eu: "43" },
  { uk: "9.5", us: "10.5", eu: "44" },
  { uk: "10", us: "11", eu: "45" },
  { uk: "11", us: "12", eu: "46" },
];

const WOMEN_SIZES = [
  { uk: "3", us: "5", eu: "36" },
  { uk: "3.5", us: "5.5", eu: "36.5" },
  { uk: "4", us: "6", eu: "37" },
  { uk: "4.5", us: "6.5", eu: "37.5" },
  { uk: "5", us: "7", eu: "38" },
  { uk: "5.5", us: "7.5", eu: "38.5" },
  { uk: "6", us: "8", eu: "39" },
  { uk: "6.5", us: "8.5", eu: "40" },
  { uk: "7", us: "9", eu: "41" },
  { uk: "7.5", us: "9.5", eu: "41.5" },
  { uk: "8", us: "10", eu: "42" },
];

export function SizeGuideModal({ open, onClose, sizes = [] }) {
  const [tab, setTab] = useState("men");
  if (!open) return null;
  const rows = tab === "men" ? MEN_SIZES : WOMEN_SIZES;

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(28,28,28,0.45)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 300,
        padding: 24,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "100%",
          maxWidth: 440,
          maxHeight: "85vh",
          background: C.bg,
          borderRadius: 20,
          boxShadow: "0 30px 80px rgba(0,0,0,0.3)",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            padding: "18px 22px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            background: C.white,
            borderBottom: "1px solid rgba(196,193,183,0.3)",
          }}
        >
          <div style={{ fontSize: 17, fontWeight: 900, color: C.charcoal, letterSpacing: "-0.3px" }}>
            Size Guide
          </div>
          <button
            onClick={onClose}
            style={{ background: "transparent", border: "none", cursor: "pointer", padding: 6 }}
          >
            <Icon name="x" size={18} color={C.charcoal} />
          </button>
        </div>

        <div style={{ padding: 22, overflowY: "auto" }}>
          <div
            style={{
              display: "flex",
              gap: 6,
              padding: 4,
              background: C.cream,
              borderRadius: 12,
              marginBottom: 16,
            }}
          >
            {[
              { id: "men", label: "Men" },
              { id: "women", label: "Women" },
            ].map((t) => (
              <button
                key={t.id}
                onClick={() => setTab(t.id)}
                style={{
                  flex: 1,
                  padding: "9px 12px",
                  border: "none",
                  background: tab === t.id ? C.white : "transparent",
                  borderRadius: 10,
                  fontSize: 13,
                  fontWeight: 800,
                  color: tab === t.id ? C.charcoal : C.muted,
                  cursor: "pointer",
                  fontFamily: "inherit",
                  boxShadow: tab === t.id ? "0 1px 3px rgba(0,0,0,0.06)" : "none",
                }}
              >
                {t.label}
              </button>
            ))}
          </div>

          {sizes.length > 0 && (
            <>
              <div
                style={{
                  fontSize: 10.5,
                  fontWeight: 800,
                  color: C.muted,
                  textTransform: "uppercase",
                  letterSpacing: 1,
                  marginBottom: 8,
                }}
              >
                Available for this product
              </div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 18 }}>
                {sizes.map((s) => (
                  <div
                    key={s}
                    style={{
                      padding: "8px 14px",
                      background: C.cream,
                      border: `1px solid ${C.dustDk}`,
                      borderRadius: 10,
                      fontSize: 13,
                      fontWeight: 800,
                      color: C.charcoal,
                    }}
                  >
                    {s}
                  </div>
                ))}
              </div>
            </>
          )}

          <div
            style={{
              fontSize: 10.5,
              fontWeight: 800,
              color: C.muted,
              textTransform: "uppercase",
              letterSpacing: 1,
              marginBottom: 8,
            }}
          >
            {tab === "men" ? "Men's conversion" : "Women's conversion"}
          </div>
          <div
            style={{
              borderRadius: 12,
              overflow: "hidden",
              border: `1px solid ${C.dustDk}`,
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                background: C.hunter,
                padding: "10px 12px",
              }}
            >
              {["UK", "US", "EU"].map((h) => (
                <div
                  key={h}
                  style={{
                    fontSize: 11.5,
                    fontWeight: 800,
                    color: C.dust,
                    textAlign: "center",
                    letterSpacing: 0.5,
                  }}
                >
                  {h}
                </div>
              ))}
            </div>
            {rows.map((r, i) => (
              <div
                key={r.eu}
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  padding: "9px 12px",
                  background: i % 2 === 0 ? C.white : C.cream,
                  fontSize: 13,
                  fontWeight: 700,
                  color: C.charcoal,
                  textAlign: "center",
                }}
              >
                <div>{r.uk}</div>
                <div>{r.us}</div>
                <div>{r.eu}</div>
              </div>
            ))}
          </div>

          <div
            style={{
              marginTop: 14,
              fontSize: 11.5,
              color: C.muted,
              padding: 10,
              background: C.cream,
              borderRadius: 8,
              lineHeight: 1.5,
            }}
          >
            Tip: measure your foot length from heel to longest toe, then match to EU size. If
            between sizes, size up for comfort.
          </div>
        </div>

        <div
          style={{
            padding: "14px 22px",
            background: C.white,
            borderTop: "1px solid rgba(196,193,183,0.3)",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "10px 20px",
              background: C.hunter,
              color: C.dust,
              border: "none",
              borderRadius: 12,
              fontSize: 13,
              fontWeight: 800,
              cursor: "pointer",
              fontFamily: "inherit",
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
